<template>
  <div class="blex w-1/2 lg:w-1/4 pb-40 lg:pb-90 px-16 lg:px-30">
    <div class="profile">
      <img src="@/assets/images/pages/main/team/teamCircle.svg" class="outline">
      <!-- 프로필 사진     -->
      <img :src="value.profile" class="profile-img">
    </div>
    <div class="blex pt-20 lg:pt-26 w-full">
      <div class="text-white font-medium text-2xs lg:text-2xl w-full blex pb-8 lg:pb-16 text-center">
        {{ value.position }}
      </div>
      <div class="text-light-gray font-medium text-2xs lg:text-xl w-full blex">
        {{ value.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'profile',

  props: {
    value: {
      type: Object
    }
  },
  watch: {
    deep: true,
    mediate: true,
    value: {
      handler(val) {
        this.value = val
      }
    }
  }
}
</script>

<style scoped lang="scss">
div::v-deep {
  .profile {
    position: relative;
    width: 182px;
    height: 182px;
    @media screen and (max-width: 1024px) {
      width: 80px;
      height: 80px;
    }

    .outline {
      @media screen and (max-width: 1024px) {
        width: 100%;

      }
    }

    .profile-img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 160px;
      height: 160px;
      border-radius: 50%;
      border: 1px solid #e7e7e7;
      object-fit: cover;

      @media screen and (max-width: 1024px) {
        width: 60px;
        height: 60px;
      }
    }
  }

}


</style>
